<template>
  <div :class="scope.clsPrefix">
    <!-- 智擎工作台（/ 恒为经典工作台，旧版不再渲染） -->
    <SmartWorkbench v-if="isSmartHome" />

    <!-- 普通工作台模式 -->
    <template v-if="!isSmartHome">
      <!-- v-if="!isEmbedded" -->
      <div
        v-if="false"
        :class="scope.clsPrefix + '_leftapp'"
        ref="leftapp"
        @mouseenter="expandSidebar"
        @mouseleave="onLeftappMouseLeave"
        :style="{ left: sidebarWidth }"
      >
        <div :class="scope.clsPrefix + '_leftapp_list'" ref="appList">
          <div
            v-for="(item, index) in openedApp"
            :key="index"
            :class="
              $route.meta.id == item.id
                ? `${scope.clsPrefix}_appitem active`
                : `${scope.clsPrefix}_appitem`
            "
            @click="handleClick(item)"
            @mouseenter="
              onAppMouseEnter(item, $event)
              showIcon(item.id, 'appCancelShow')
            "
            @mouseleave="
              onAppMouseLeave()
              hideIcon(item.id, 'appCancelShow')
            "
          >
            <transition name="slide">
              <div
                v-show="appCancelShow[item.id]"
                :key="item.id"
                @click.stop="cancelOpenedApp(item.id)"
                class="el-icon-error app-cancel"
              ></div>
            </transition>
            <img :src="item.icon" alt="appIcon" />
          </div>
        </div>
        <div
          v-show="hoverTip.visible"
          class="leftapp-tooltip"
          :style="{ top: hoverTip.top + 'px', left: hoverTip.left + 'px' }"
        >
          {{ hoverTip.text }}
        </div>
        <div
          v-if="!isExpanded && !isEmbedded"
          :class="scope.clsPrefix + '_indicator'"
          @click="expandSidebar"
          @mouseenter="expandSidebar"
        >
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <router-view> </router-view>
    </template>
  </div>
</template>

<script>
import { incrementQuickApps } from '@/api/app.js'
import microApp from '@micro-zoe/micro-app'
import { mapState } from 'vuex'
import SmartWorkbench from '@/views/smart-workbench/index.vue'
export default {
  // 组件名称
  name: 'IndexMain',
  components: { SmartWorkbench },
  // 数据
  data() {
    return {
      isExpanded: false,
      sidebarWidth: '-52px',
      appCancelShow: {},
      hideTimer: null,
      hoverTip: { visible: false, text: '', top: 0, left: 0 },
      // 私有变量
      scope: {
        // class前缀
        clsPrefix: 'index-main'
      }
    }
  },
  props: {
    isEmbedded: { type: Boolean, default: false }
  },
  computed: {
    ...mapState('permission', ['openedApp']),
    // / 恒为经典工作台，首页不再渲染旧版智擎工作台
    isSmartHome() {
      return false
    }
  },
  // 创建完成
  created() {},
  // 挂载完成
  mounted() {},
  // 方法
  methods: {
    expandSidebar() {
      // 鼠标进入时，若存在待执行的收起定时器则取消，防止闪烁
      if (this.hideTimer) {
        clearTimeout(this.hideTimer)
        this.hideTimer = null
      }
      this.isExpanded = true
      this.sidebarWidth = '0px' // 展开后的宽度
      this.scrollToActiveApp()
    },
    hideSidebar() {
      // 鼠标离开时，设置一个可取消的收起定时器，避免来回抖动
      if (this.hideTimer) {
        clearTimeout(this.hideTimer)
        this.hideTimer = null
      }
      this.hideTimer = setTimeout(() => {
        this.isExpanded = false
        this.sidebarWidth = '-52px' // 收起后的宽度
        this.hideTimer = null
      }, 800)
    },
    // 侧栏 mouseleave：若移入的是 el-tooltip 浮层，则不触发收起
    onLeftappMouseLeave(event) {
      const toEl = event && (event.relatedTarget || event.toElement)
      if (this.isInsideTooltip(toEl)) {
        // 鼠标进入了 tooltip 浮层，保持展开
        return
      }
      this.hideSidebar()
    },
    // 判断目标元素是否在 el-tooltip 浮层内
    isInsideTooltip(el) {
      let cur = el
      while (cur) {
        if (cur.classList && cur.classList.contains('el-tooltip__popper')) {
          return true
        }
        cur = cur.parentElement
      }
      return false
    },
    scrollToActiveApp() {
      this.$nextTick(() => {
        const activeElement = this.$refs.appList?.querySelector('.active')
        if (activeElement) {
          activeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
        }
      })
    },
    /**
     * 显示添加应用按钮
     * @returns {void}
     */
    showIcon(id, data) {
      this.$set(this[data], id, true)
    },
    cancelOpenedApp(id) {
      this.$store.commit('permission/CANCEL_OPENED_APP', id)
    },
    /**
     * 隐藏添加应用按钮
     * @returns {void}
     */
    hideIcon(id, data) {
      this.$set(this[data], id, false)
    },
    handleClick(appItem) {
      if (appItem.context === this.$route.meta.context) {
        window.reload()
      }
      // const res = await getAppApplyUrl({ appId: appItem.id })
      // const accessApplyUrl = res.data
      // sessionStorage.setItem('accessApplyUrl', accessApplyUrl)
      if (appItem.canAccess) {
        incrementQuickApps(appItem.id).then((res) => {
          console.log(`访问${appItem.name}`)
        })
        if (appItem.enterNeedFresh == '1') {
          microApp.unmountAllApps().then(() => {
            window.open(
              window.location.origin + '/' + appItem.context + '/',
              '_self'
            )
          })
        } else if (appItem.type == 'HREF') {
          window.open(appItem.url, '_blank')
        } else {
          microApp.unmountAllApps().then(() => {
            this.$router.push(`/${appItem.context}/`)
          })
        }
      } else {
        this.$router.push(
          `/noPermission?appName=${appItem.name}&appId=${appItem.id}`
        )
      }
      // 确保在点击后隐藏侧边栏
      this.$nextTick(() => {
        this.hideSidebar()
      })
    },
    // 应用图标 hover：显示自定义提示
    onAppMouseEnter(item, event) {
      if (!this.$refs.leftapp) return
      const rect = event.currentTarget.getBoundingClientRect()
      const crect = this.$refs.leftapp.getBoundingClientRect()
      // 将提示定位在图标右侧，垂直居中
      this.hoverTip.text = item.name
      this.hoverTip.top = rect.top - crect.top + rect.height / 2 // 配合 CSS 的 translateY(-50%)
      this.hoverTip.left = rect.right - crect.left + 8
      this.hoverTip.visible = true
    },
    // 离开图标：隐藏提示
    onAppMouseLeave() {
      this.hoverTip.visible = false
    }
  }
}
</script>

<style lang="scss">
// 组件样式
$class-prefix: 'index-main';
.#{$class-prefix} {
  position: relative;
  flex: 1;
  height: 100%;
  &_leftapp {
    width: 54px;
    background: #ffffff5c;
    box-shadow: 3px 4px 10px 0 #121e7033;
    border-radius: 0 8px 8px 0;
    backdrop-filter: blur(2px);
    position: absolute;
    top: 6px;
    left: -52px;
    height: calc(100% - 26px);
    z-index: 10;
    transition: left 0.3s ease-in-out; // 添加过渡动画
    padding: 10px 2px;
    &_list {
      height: 100%;
      overflow-y: auto;
      white-space: nowrap; // 添加这一行防止元素换行
      // -ms-overflow-style: none; /* IE 和 Edge */
      scrollbar-width: none; /* Firefox */
    }
    // 自定义悬浮提示样式
    .leftapp-tooltip {
      position: absolute;
      transform: translateY(-50%);
      z-index: 20;
      background: rgba(0, 0, 0, 0.85);
      color: #fff;
      font-size: 12px;
      line-height: 1;
      padding: 6px 8px;
      border-radius: 4px;
      white-space: nowrap;
      pointer-events: none; // 不抢占鼠标事件，避免影响容器的 hover 逻辑
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    }
  }
  // &_appname {
  //   font-size: 12px;
  //   text-align: center;
  //   white-space: nowrap;
  //   overflow: hidden;
  //   text-overflow: ellipsis;
  // }
  &_appitem.active {
    background: #afbfff;
    box-shadow: 0 2px 4px 0 #0000001a;
    border-radius: 8px;
  }
  &_appitem {
    width: 50px;
    height: 50px;
    padding: 4px;
    margin-bottom: 22px;
    position: relative;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 4px 0 #0000001a;
      border-radius: 8px;
      background-color: #fff;
    }
    img {
      width: 42px;
      height: 42px;
      border: 3px solid #fff;
      border-radius: 8px;
    }
    .app-cancel {
      position: absolute;
      top: 0px;
      right: 0px;
      font-size: 15px;
      color: #333;
    }
  }
  // 添加指示器样式
  &_indicator {
    position: absolute;
    top: 50%;
    right: -8px;
    transform: translateY(-50%);
    width: 8px;
    height: 120px;
    background: #4a5ff3;
    box-shadow: 0 0 10px 0 #00000008;
    border-radius: 0 8px 8px 0;
    backdrop-filter: blur(10px);
    cursor: pointer;
    font-size: 8px;
    color: #fff;
    line-height: 120px;
    // &::before {
    //   content: "";
    //   position: absolute;
    //   top: 50%;
    //   left: 50%;
    //   transform: translate(-50%, -50%);
    //   width: 0;
    //   height: 0;
    //   border-top: 2px solid transparent;
    //   border-bottom: 2px solid transparent;
    //   border-left: 2px solid #fff;
    // }
  }

  // 添加收起按钮样式
  &_collapse-btn {
    position: absolute;
    top: 50%;
    right: -20px;
    transform: translateY(-50%);
    width: 20px;
    height: 60px;
    background-color: #4a5ff3;
    border-radius: 0px 10px 10px 0px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      color: #fff;
      font-size: 12px;
    }
  }
}
</style>
